module.exports = __webpack_public_path__ + "img/logo.4cbe708d.png";